module.exports = __webpack_public_path__ + "img/georgia-virtual.45a04874.png";